import React from 'react';
import { SystemMessageData } from '@/types';
import { Info } from 'lucide-react';
import { useAppStore } from '@/hooks/useAppStore';
import { useTranslation } from '@/lib/translate';

interface SystemBubbleProps {
    data: SystemMessageData;
}

export const SystemBubble: React.FC<SystemBubbleProps> = ({
    data,
}) => {
    const preferredLanguage = useAppStore((state) => state.preferredLanguage);
    const t = useTranslation(preferredLanguage);

    // Translate context change messages dynamically
    let displayMessage = data.message;
    if (data.message === "CONTEXT_CHANGE" && data.contextData) {
        const { presetOption, contextInput } = data.contextData;
        
        if (!presetOption || presetOption === "") {
            displayMessage = t("Conversation context removed");
        } else if (presetOption === "customize" && contextInput) {
            displayMessage = `${t("Conversation context changed to")}: "${contextInput}"`;
        } else {
            const contextName = t(presetOption) || presetOption;
            displayMessage = `${t("Conversation context changed to")} "${t(`ConversationContext_${contextName}`)}"`;
        }
    }

    return (
        <div className={`message-container flex flex-col items-center mb-4 animate-fadeIn`}>
            <div className={`flex flex-row gap-2 px-5 py-2 text-xs rounded-full bg-chotto-chat-notification shadow-xs items-center`}>
                <Info size={12} className="text-neutral-500 dark:text-neutral-400" />
                <span className="text-secondary-foreground font-medium">
                    {displayMessage}
                </span>
            </div>
        </div>
    );
};
